/**
 * Tenant constants ported from legacy `environment.commons.ts`.
 */

export interface TenantOption {
  tenantId: string;
  value: string;
  viewValue: string;
}

export const tenants: TenantOption[] = [
  { tenantId: 'TPSA', value: 'tpsa', viewValue: 'Oechsle' },
  { tenantId: 'HPSA', value: 'hpsa', viewValue: 'Promart Perú' },
  { tenantId: 'PVEA', value: 'spsa', viewValue: 'Plaza Vea' },
  { tenantId: 'RPLAZA', value: 'rp', viewValue: 'Real Plaza' },
  { tenantId: 'HPSAEC', value: 'hesa', viewValue: 'Promart Ecuador' },
  { tenantId: 'MKR', value: 'mkr', viewValue: 'Makro' },
];

export type TenantKey = 'HPSA' | 'TPSA' | 'PVEA' | 'RPLAZA' | 'HPSAEC' | 'MKR';

export interface TenantAnalog {
  tenantId: string;
  tenantName: string;
}

/** Organization code (cc-auth) -> RT tenant. */
export const tenantEquivalents: Record<TenantKey, TenantAnalog> = {
  HPSA: { tenantId: 'hpsa', tenantName: 'Promart Perú' },
  TPSA: { tenantId: 'tpsa', tenantName: 'Oechsle' },
  PVEA: { tenantId: 'spsa', tenantName: 'Plaza Vea' },
  RPLAZA: { tenantId: 'rp', tenantName: 'Real Plaza' },
  HPSAEC: { tenantId: 'hesa', tenantName: 'Promart Ecuador' },
  MKR: { tenantId: 'mkr', tenantName: 'Makro' },
};

/** RT tenant (upper case) -> IRMA tenant id. Legacy `tenantMapping` in picker / customer. */
export const irmaTenantMapping: Record<string, string> = {
  SPSA: 'PVEA',
  RP: 'RPLAZA',
  HESA: 'HPSAEC',
};

export function toIrmaTenant(tenantId: string): string {
  const upper = tenantId.toUpperCase();
  return irmaTenantMapping[upper] || upper;
}

/** Tenants whose exit QR can be validated by security (legacy `withdrawalValidationEnabled`). */
export const withdrawalValidationEnabled: string[] = ['hpsa', 'tpsa', 'spsa', 'hesa', 'mkr'];

/** Tenants without SMS support: the picker resends the withdrawal QR only by email. */
export const smsResendDisabled: string[] = ['hesa'];
